export default __webpack_public_path__ + "static/media/968.17d4a60a.png";